export default __webpack_public_path__ + "static/media/weather-app.758d6711.png";